/**
 * HowToInstallDeviceDriver.tsx
 * @fileoverview デバイスドライバーインストール方法のページ
 */

import { Step } from "../components/Step";
import { DescriptionBox } from "../components/DescriptionBox";
import { Link } from "react-router-dom";
import InstallDeviceDriverStep1 from "./img/InstallDeviceDriverStep1.png";
import InstallDeviceDriverStep2 from "./img/InstallDeviceDriverStep2.png";
import InstallDeviceDriverStep3 from "./img/InstallDeviceDriverStep3.png";
import InstallDeviceDriverStep4 from "./img/InstallDeviceDriverStep4.png";
import InstallDeviceDriverStep5 from "./img/InstallDeviceDriverStep5.png";
import InstallDeviceDriverStep5_Sub from "./img/InstallDeviceDriverStep5_Sub.png";

const steps_install = [
  { step: "1.", text: "CDM212364_Setup.exeを起動してください。", 
    image: InstallDeviceDriverStep1, alt: "CDM212364_Setup.exe起動時画面",},
  
  { step: "2.", text: "[Extract]を押してください。" ,
    image: InstallDeviceDriverStep2, alt: "Extract" },

  { step: "3.", text: "[次へ]を押してください。" ,
    image: InstallDeviceDriverStep3, alt: "次へ" },

  { step: "4.", text: "[同意します]を選択して，[次へ]を押してください。" ,
    image: InstallDeviceDriverStep4, alt: "使用許諾" },

  { step: "5.", text: "[完了]を押してください。",
    image: InstallDeviceDriverStep5, alt: "完了",
    point_text: "下のように表示された場合は，すでにデバイスドライバーがインストールされています。[完了]を押して終了してください。",
    point_image: InstallDeviceDriverStep5_Sub, point_alt: "完了(インストール済み)" },
];
/**
 * How to install device driver
 * @returns {JSX.Element} デバイスドライバーインストール方法の JSX element
 */
export function HowToInstallDeviceDriver(): JSX.Element {
  return (
    <div>
      <section className="c-section">
        <h2 className="p-heading-2">デバイスドライバーのインストール方法</h2>        
        <p className="c-text">
          GasLogReaderの使用にはデバイスドライバーのインストールが必要です。
          以下の手順に従って，デバイスドライバーをインストールしてください。
        </p>
        <DescriptionBox description = {<>インストーラーのダウンロードがお済みでない方は、
          <Link to="/gas-log-reader/HowToDownload">ダウンロード方法</Link>
			    を参考にして、インストーラーをダウンロードしてください。</>}/>
        {steps_install.map((step, index) => (
          <Step key={index} step={step.step} text={step.text} image={step.image} point_text={step.point_text} point_image={step.point_image} point_alt={step.point_alt}/>
        ))}
      </section>
    </div>
  );
}
